import React, { useState, useEffect, useRef } from "react"
import { Modal, Alert } from "react-bootstrap"
import { FaPlus, FaTimes, FaCheck, FaArrowRight, FaImage, FaTag, FaCog, FaTicketAlt, FaInfoCircle } from "react-icons/fa"
import LinkedToTab from "./LinkedToTab"
import axios from "axios"
import { localserver } from "../../../api/common"
import { showToast } from "../../Shared/ToastMessage"
import { GetTaxSettings, uploadFilesAWS } from "../../../api/Webservices"
import { useUser } from "../../AdminUsers/UserContext"

const CreateAddOns = ({ show, onHide, onSubmit, eventId: initialEventId, addonToEdit }) => {
  const { settingsDetails, fetchSettingsDetails } = useUser()
  const [eventId, setEventId] = useState(initialEventId)
  const [addOnData, setAddOnData] = useState({
    id: null,
    name: "",
    quantity: "",
    description: "",
    pricing: "free",
    currency: "INR",
    price: "",
    image: null,
    imagePreview: null,
    addOnType: "single",
    variants: [],
    variantType: "",
    taxEnabled: false,
    taxes: [],
    taxIncludedInPrice: true,
    addOnStatus: "",
  })
  const [ticketList, setTicketList] = useState([])
  const [isVisible, setIsVisible] = useState(false)
  const [showDescription, setShowDescription] = useState(false)
  const [showVariantModal, setShowVariantModal] = useState(false)
  const [showTaxSettingsDrawer, setShowTaxSettingsDrawer] = useState(false)
  const [currentVariant, setCurrentVariant] = useState({
    name: "",
    quantity: "",
    price: "",
  })
  const [activeTab, setActiveTab] = useState("basic")
  const [isLoadingTickets, setIsLoadingTickets] = useState(false)
  const [ticketError, setTicketError] = useState(null)
  const fileInputRef = useRef(null)
  const [addOnLogo, setAddOnLogo] = useState("")
  const [uploadedLogo, setUploadedLogo] = useState(null)
  const [imageError, setImageError] = useState("")

  useEffect(() => {
    setEventId(initialEventId)
  }, [initialEventId])

  useEffect(() => {
    console.log("addonToEdit:", addonToEdit)
    if (addonToEdit) {
      const normalizedAddOnType =
        addonToEdit.addons_type === "variant" ? "variants" : addonToEdit.addons_type || "single"
      const taxSettingsData = JSON.parse(settingsDetails?.tax_settings || "{}")
      const taxIncludedInPriceFromSettings = taxSettingsData.tax_display === "include"
      setAddOnData({
        id: addonToEdit.id || null,
        name: addonToEdit.add_on_name || "",
        quantity: addonToEdit.quantity || "",
        description: addonToEdit.description || "",
        pricing: addonToEdit.price_type || "free",
        currency: addonToEdit.currency || "",
        price: addonToEdit.price || "",
        image: addonToEdit.image || null,
        imagePreview: addonToEdit.image || null,
        addOnType: normalizedAddOnType,
        variants:
          addonToEdit.variant_options?.map((v) => ({
            name: v["Variant name"] || v.variant_name || "",
            quantity: v["Quantity available"] || v.quantity_available || "",
            price: v["Variant price"] || v.variant_price || "",
          })) || [],
        variantType: addonToEdit.variant_type || "",
        // taxEnabled: !!addonToEdit.tax_type,
        taxEnabled: addonToEdit.tax_type === "Including Tax" ? true : false,
        taxes:
          addonToEdit.tax_options?.map((t) => ({
            name: t.tax_name || "",
            percentage: t.tax_percentage?.toString() || "",
            registrationNumber: t.registration_number || "",
            taxIncludedInPrice: addonToEdit.tax_type === "Including Tax",
          })) || [],
        taxIncludedInPrice: addonToEdit.tax_type === "Including Tax" || taxIncludedInPriceFromSettings,
        addOnStatus: addonToEdit.addon_status || "",
      })
      setShowDescription(!!addonToEdit.description)
      setAddOnLogo(addonToEdit.image || "")
      setUploadedLogo(addonToEdit.image || null)
      setTicketList(
        (addonToEdit.linked_tickets || []).map((ticket) => ({
          id: ticket.ticket_id,
          ticket_name: ticket.ticket_name || "Unknown Ticket",
          selected: true,
          maxQuantity: ticket.max_quantity || 1,
        })),
      )
    } else {
      const taxSettingsData = JSON.parse(settingsDetails?.tax_settings || "{}")
      const taxIncludedInPriceFromSettings = taxSettingsData.tax_display === "include"
      setAddOnData({
        id: null,
        name: "",
        quantity: "",
        description: "",
        pricing: "free",
        currency: "INR",
        price: "",
        image: null,
        imagePreview: null,
        addOnType: "single",
        variants: [],
        variantType: "",
        taxEnabled: false,
        taxes: [],
        taxIncludedInPrice: taxIncludedInPriceFromSettings,
        addOnStatus: "",
      })
      setShowDescription(false)
      setAddOnLogo("")
      setUploadedLogo(null)
      setTicketList([])
    }
  }, [addonToEdit, settingsDetails])

  useEffect(() => {
    if (show) {
      setIsVisible(true)
      document.body.style.overflow = "hidden"
    } else {
      setTimeout(() => {
        setIsVisible(false)
        document.body.style.overflow = ""
      }, 300)
    }
    return () => {
      document.body.style.overflow = ""
    }
  }, [show])

  const getTicketsByEventID = async () => {
    setIsLoadingTickets(true)
    setTicketError(null)
    const storedEventId = localStorage.getItem("eventId") || eventId
    if (!storedEventId) {
      setTicketError("No event ID found. Please select an event.")
      setIsLoadingTickets(false)
      showToast("No event ID found. Please select an event.", "error")
      return
    }
    try {
      const response = await axios.post(
        `${localserver}/get_ticket_by_event_id`,
        {
          event_id: storedEventId,
          ticket_status: "all",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success && Array.isArray(response.data.tickets)) {
        const updatedTickets = response.data.tickets
          .filter((ticket) => ticket.onsale_status === "enable")
          .map((ticket) => {
            const linkedTicket = addonToEdit?.linked_tickets?.find((lt) => lt.ticket_id === ticket.id)
            return {
              id: ticket.id,
              ticket_name: ticket.ticket_name || ticket.name || "Unnamed Ticket",
              selected: linkedTicket ? true : false,
              maxQuantity: linkedTicket ? linkedTicket.max_quantity : 1,
            }
          })
        setTicketList(updatedTickets)
      } else {
        setTicketError("No tickets found for this event.")
        showToast("No tickets found for this event.", "error")
      }
    } catch (error) {
      console.error("Error fetching tickets:", error)
      setTicketError("Failed to fetch tickets. Please try again.")
      showToast("Failed to fetch tickets. Please try again.", "error")
    } finally {
      setIsLoadingTickets(false)
    }
  }

  useEffect(() => {
    getTicketsByEventID()
  }, [eventId, addonToEdit])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setAddOnData({
      ...addOnData,
      [name]: value,
    })
  }

  const handleVariantInputChange = (e) => {
    const { name, value } = e.target
    setCurrentVariant({
      ...currentVariant,
      [name]: value,
    })
  }

  const handleAddVariant = () => {
    if (currentVariant.name && currentVariant.price) {
      if (addOnData.quantity && currentVariant.quantity === "") {
        showToast("Cannot set unlimited quantity for variant when overall quantity is limited.", "error")
        return
      }
      const newQty = Number.parseInt(currentVariant.quantity, 10) || 0
      const currentSum = addOnData.variants.reduce((sum, v) => {
        return sum + (Number.parseInt(v.quantity, 10) || 0)
      }, 0)
      if (addOnData.quantity && currentSum + newQty > Number.parseInt(addOnData.quantity, 10)) {
        showToast("Total variant quantities cannot exceed the overall quantity available.", "error")
        return
      }
      setAddOnData({
        ...addOnData,
        variants: [...addOnData.variants, { ...currentVariant }],
      })
      setCurrentVariant({ name: "", quantity: "", price: "" })
      setShowVariantModal(false)
    } else {
      showToast("Variant name and price are required.", "error")
    }
  }

  const handleRemoveVariant = (index) => {
    const updatedVariants = [...addOnData.variants]
    updatedVariants.splice(index, 1)
    setAddOnData({
      ...addOnData,
      variants: updatedVariants,
    })
  }

  const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/jpg"]
  const MAX_IMAGE_SIZE = 5 * 1024 * 1024
  const MIN_DIMENSION = 90
  const MAX_DIMENSION = 160

  const validateImage = (file) => {
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      return `Add-on image must be JPG, JPEG, or PNG format.`
    }
    if (file.size > MAX_IMAGE_SIZE) {
      return `Add-on image size must not exceed 5MB.`
    }
    return new Promise((resolve) => {
      const img = new Image()
      const objectUrl = URL.createObjectURL(file)
      img.onload = () => {
        const isWidthValid = img.width >= MIN_DIMENSION && img.width <= MAX_DIMENSION
        const isHeightValid = img.height >= MIN_DIMENSION && img.height <= MAX_DIMENSION
        if (
          !(isWidthValid && isHeightValid) ||
          (img.width !== 150 && img.height !== 100 && img.width !== 100 && img.height !== 150)
        ) {
          URL.revokeObjectURL(objectUrl)
          resolve(
            `Add-on image dimensions must be approximately 150 × 100 or 100 × 150 pixels (within 90-160 × 90-160).`,
          )
        } else {
          URL.revokeObjectURL(objectUrl)
          resolve(null)
        }
      }
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl)
        resolve(`Failed to load Add-on image. Please try again.`)
      }
      img.src = objectUrl
    })
  }

  const handleImageUpload = async (event) => {
    const file = event.target.files[0]
    if (!file) return

    const validationError = await validateImage(file)
    if (validationError) {
      setImageError(validationError)
      showToast(validationError, "error")
      return
    }

    try {
      const res = await uploadFilesAWS({ upload_files: file })
      if (res.data && res.data.success === true) {
        const uploadedUrl = res.data.uploadedUrls.upload_files[0]
        setAddOnLogo(uploadedUrl)
        setUploadedLogo(URL.createObjectURL(file))
        setImageError("")
        setAddOnData({
          ...addOnData,
          image: uploadedUrl,
          imagePreview: URL.createObjectURL(file),
        })
      } else {
        showToast(res.message, "error")
      }
    } catch (error) {
      console.error("Error uploading image:", error)
      showToast("Failed to upload add-on image. Please try again.", "error")
    }
  }

  const handleRemoveImage = () => {
    setAddOnData({
      ...addOnData,
      image: null,
      imagePreview: null,
    })
    setAddOnLogo("")
    setUploadedLogo(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ""
    }
  }

  const handleAddDescription = () => {
    setShowDescription(true)
  }

  const handleRemoveDescription = () => {
    setAddOnData({
      ...addOnData,
      description: "",
    })
    setShowDescription(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!addOnData.name) {
      showToast("Add-on name is required.", "error")
      return
    }
    if (addOnData.addOnType === "variants" && addOnData.variants.length === 0) {
      showToast("At least one variant is required for Add-on with variants.", "error")
      return
    }
    if (addOnData.addOnType === "variants" && addOnData.variants.some((variant) => !variant.price)) {
      showToast("All variants must have a price.", "error")
      return
    }
    if (addOnData.pricing === "paid" && !addOnData.currency) {
      showToast("Currency are required for paid add-ons.", "error")
      return
    }
    if (addOnData.pricing === "paid" && addOnData.addOnType !== "variants" && !addOnData.price) {
      showToast("Price are required for paid add-ons.", "error")
      return
    }
    if (addOnData.taxEnabled && addOnData.taxes.length === 0) {
      showToast("Taxes are enabled but no tax settings are configured. Please add tax details.", "error")
      return
    }
    if (addOnData.taxEnabled && addOnData.taxes.some((tax) => !tax.name || !tax.percentage)) {
      showToast("All taxes must have a name and percentage.", "error")
      return
    }
    if (addOnData.addOnType === "variants" && addOnData.quantity) {
      const overall = Number.parseInt(addOnData.quantity, 10)
      if (addOnData.variants.some((v) => v.quantity === "")) {
        showToast("All variants must have a specified quantity when overall quantity is limited.", "error")
        return
      }
      const sum = addOnData.variants.reduce((s, v) => s + (Number.parseInt(v.quantity, 10) || 0), 0)
      if (sum > overall) {
        showToast("Total variant quantities exceed the overall quantity available.", "error")
        return
      }
    }

    const selectedTickets = ticketList
      .filter((ticket) => ticket.selected)
      .map((ticket) => ({
        ticket_id: ticket.id,
        max_quantity: ticket.maxQuantity,
      }))

    const apiData = {
      event_id: eventId || localStorage.getItem("eventId") || 1,
      addons_type: addOnData.addOnType === "single" ? "single" : "variant",
      image: addOnLogo || "",
      add_on_name: addOnData.name,
      description: addOnData.description,
      price_type: addOnData.pricing,
      price: addOnData.pricing === "paid" ? Number.parseFloat(addOnData.price) || 0 : 0,
      currency: addOnData.pricing === "paid" ? addOnData.currency : "",
      tax_type: addOnData.taxEnabled ? (addOnData.taxIncludedInPrice ? "Including Tax" : "Excluding Tax") : "No Tax",
      tax_options: addOnData.taxEnabled
        ? addOnData.taxes.map((tax) => ({
          tax_name: tax.name,
          tax_percentage: Number.parseFloat(tax.percentage) || 0,
          registration_number: tax.registrationNumber || "",
        }))
        : [],
      variant_options:
        addOnData.addOnType === "variants"
          ? addOnData.variants.map((variant) => ({
            variant_name: variant.name,
            quantity_available: Number.parseInt(variant.quantity) || 0,
            variant_price: Number.parseFloat(variant.price) || 0,
          }))
          : [],
      addon_status: addOnData.addOnStatus || "",
      linked_tickets: selectedTickets,
      // quantity: Number.parseInt(addOnData.quantity) || 0,
      quantity: addOnData.addOnType === "variants"
        ? addOnData.variants.reduce((sum, variant) => sum + (Number.parseInt(variant.quantity) || 0), 0)
        : Number.parseInt(addOnData.quantity) || 0,
    }

    try {
      console.log("API Data to send:", apiData)
      const response = addOnData.id
        ? await axios.post(
          `${localserver}/update_addon`,
          { ...apiData, addon_id: addOnData.id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          },
        )
        : await axios.post(`${localserver}/create_addon`, apiData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })

      if (response.data.success) {
        showToast(addOnData.id ? "Add-on updated successfully!" : "Add-on created successfully!", "success")
        onSubmit(addOnData)
        setAddOnData({
          id: null,
          name: "",
          quantity: "",
          description: "",
          pricing: "free",
          currency: "INR",
          price: "",
          image: null,
          imagePreview: null,
          addOnType: "single",
          variants: [],
          variantType: "",
          taxEnabled: false,
          taxes: [],
          taxIncludedInPrice: true,
        })
        setShowDescription(false)
        setUploadedLogo(null)
        setAddOnLogo("")
        setTicketList([])
        onHide()
      } else {
        showToast(
          response.data.message || (addOnData.id ? "Failed to update add-on." : "Failed to create add-on."),
          "error",
        )
      }
    } catch (error) {
      console.error("Error saving add-on:", error)
      showToast(
        addOnData.id ? "Failed to update add-on. Please try again." : "Failed to create add-on. Please try again.",
        "error",
      )
    }
  }

  const handleAddOnTypeChange = (type) => {
    setAddOnData({
      ...addOnData,
      addOnType: type,
      variants: type === "variants" ? addOnData.variants : [],
    })
  }

  const handleTaxToggle = async () => {
    const newTaxEnabled = !addOnData.taxEnabled
    const taxSettingsData = JSON.parse(settingsDetails?.tax_settings || "{}")
    const taxIncludedInPrice = taxSettingsData.tax_display === "include"
    setAddOnData({
      ...addOnData,
      taxEnabled: newTaxEnabled,
      taxes:
        taxSettingsData.tax_options?.map((tax) => ({
          registrationNumber: taxSettingsData.tax_registration_number || "",
          name: tax.tax_name,
          percentage: tax.tax_percentage.toString(),
          taxIncludedInPrice,
        })) || [],
      taxIncludedInPrice,
    })
  }

  const handleTaxIncludedChange = (isIncluded) => {
    setAddOnData({
      ...addOnData,
      taxIncludedInPrice: isIncluded,
      taxes: addOnData.taxes.map((tax) => ({
        ...tax,
        taxIncludedInPrice: isIncluded,
      })),
    })
  }

  const openTaxSettingsDrawer = () => {
    setShowTaxSettingsDrawer(true)
  }

  const closeTaxSettingsDrawer = (taxSettings) => {
    if (taxSettings && addOnData.taxEnabled) {
      setAddOnData({
        ...addOnData,
        taxes: taxSettings.taxes.map((tax) => ({
          name: tax.name,
          percentage: tax.percentage,
          registrationNumber: taxSettings.registrationNumber || "",
          taxIncludedInPrice: taxSettings.displayOption === "include",
        })),
        taxIncludedInPrice: taxSettings.displayOption === "include",
      })
    }
    setShowTaxSettingsDrawer(false)
  }

  const goToLinkedTab = () => {
    if (!addOnData.name) {
      showToast("Add-on name is required.", "error")
      return
    }
    if (addOnData.addOnType === "variants" && addOnData.variants.length === 0) {
      showToast("At least one variant is required for Add-on with variants.", "error")
      return
    }
    if (addOnData.addOnType === "variants" && addOnData.variants.some((variant) => !variant.price)) {
      showToast("All variants must have a price.", "error")
      return
    }
    if (addOnData.pricing === "paid" && !addOnData.currency) {
      showToast("Currency are required for paid add-ons.", "error")
      return
    }
    if (addOnData.pricing === "paid" && addOnData.addOnType !== "variants" && !addOnData.price) {
      showToast("Price are required for paid add-ons.", "error")
      return
    }
    if (addOnData.addOnType === "variants" && addOnData.quantity) {
      const overall = Number.parseInt(addOnData.quantity, 10)
      if (addOnData.variants.some((v) => v.quantity === "")) {
        showToast("All variants must have a specified quantity when overall quantity is limited.", "error")
        return
      }
      const sum = addOnData.variants.reduce((s, v) => s + (Number.parseInt(v.quantity, 10) || 0), 0)
      if (sum > overall) {
        showToast("Total variant quantities exceed the overall quantity available.", "error")
        return
      }
    }
    setActiveTab("linked")
  }

  const goToBasicTab = () => {
    setActiveTab("basic")
  }

  useEffect(() => {
    fetchSettingsDetails()
  }, [])

  const renderLinkedToTab = () => {
    let totalQuantityAvailable = null
    if (addOnData.addOnType === "single") {
      totalQuantityAvailable = addOnData.quantity ? Number.parseInt(addOnData.quantity) : null
    } else if (addOnData.addOnType === "variants" && addOnData.variants.length > 0) {
      const totalVariantQuantity = addOnData.variants.reduce((sum, variant) => {
        return sum + (variant.quantity ? Number.parseInt(variant.quantity) : 0)
      }, 0)
      totalQuantityAvailable = totalVariantQuantity > 0 ? totalVariantQuantity : null
    }
    return <LinkedToTab tickets={ticketList} setTickets={setTicketList} quantityAvailable={totalQuantityAvailable} />
  }

  if (!show && !isVisible) return null

  return (
    <>

      <div
        className="extraspace_search_div1 search_div open"
        style={{
          padding: "0px",
        }}
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          style={{
            margin: "auto",
            maxWidth: "900px",

            display: "flex",
            alignItems: "self-start",
            justifyContent: "center",
          }}
        >
          <div
            className="modal-content"
            style={{
              borderRadius: "0px",
              border: "none",
              boxShadow: "0 20px 60px rgba(24, 71, 120, 0.25)",
              overflow: "hidden",
              animation: "scaleIn 0.3s ease",
              display: "flex",
              flexDirection: "column",
              maxHeight: "100vh",
            }}
          >
            {/* Header */}
            <div className="common_sidebar_header"
            >


              <div className=" ">
                <h5
                  className="heading_withpara" >
                  <div className="create_heading_innner">
                     
                      {addOnData.id ? "Edit Add-on" : "Create Add-on"} 
                  </div>
                  {/* <p>  {addOnData.id ? "Update your add-on details" : "Create a new add-on for your event"}</p> */}
                </h5>

              </div>
              <button
                onClick={() => {
                  onHide()
                  setImageError(null)
                  setActiveTab("basic")
                }}
                className="close-notification-btn"
              >
                <FaTimes />
              </button>

            </div>

            {/* Tab Navigation */}
            <div
              style={{
                background: "linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)",
                padding: "12px 32px",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <div className="tab-button-group">
                {/* Basic Details Tab */}
                <button
                  onClick={() => setActiveTab("basic")}
                  className={`custom-tab-btn ${activeTab === "basic" ? "active" : ""}`}
                >
                  <div className={`tab-icon-box ${activeTab === "basic" ? "active" : ""}`}>
                    <FaCog />
                  </div>
                  Basic Details
                </button>

                {/* Linked Tickets Tab */}
                <button
                  onClick={goToLinkedTab}
                  className={`custom-tab-btn ${activeTab === "linked" ? "active" : ""}`}
                >
                  <div className={`tab-icon-box ${activeTab === "linked" ? "active" : ""}`}>
                    <FaTicketAlt />
                  </div>
                  Linked Tickets
                </button>
              </div>

            </div>

            {/* Content Area */}
            <div
              style={{
                padding: "32px",
                overflowY: "auto",
                flex: 1,
                background: "#ffffff",
              }}
            >
              {activeTab === "basic" ? (
                <div>
                  {/* Add-on Type Selection */}
                  <div style={{ marginBottom: "22px" }}>
                    <h5 className="addon_subheading">
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          fontSize: "16px",
                        }}
                      >
                        <FaTag />
                      </div>
                      Add-on Type
                    </h5>
                    <div className="row g-3 addon_top_tab">
                      {/* Single Add-on */}
                      <div className="col-md-6">
                        <div
                          onClick={() => handleAddOnTypeChange("single")}
                          className={`addon-card ${addOnData.addOnType === "single" ? "active" : ""}`}
                        >
                          {addOnData.addOnType === "single" && (
                            <div className="addon-check">
                              <FaCheck />
                            </div>
                          )}
                          <FaTag className={`addon-icon ${addOnData.addOnType === "single" ? "active" : ""}`} />
                          <h6 className={`addon-title ${addOnData.addOnType === "single" ? "active" : ""}`}>
                            Single Add-on
                          </h6>
                          <p className={`addon-desc ${addOnData.addOnType === "single" ? "active" : ""}`}>
                            One simple option
                          </p>
                        </div>
                      </div>

                      {/* Variants Add-on */}
                      <div className="col-md-6">
                        <div
                          onClick={() => handleAddOnTypeChange("variants")}
                          className={`addon-card ${addOnData.addOnType === "variants" ? "active" : ""}`}
                        >
                          {addOnData.addOnType === "variants" && (
                            <div className="addon-check">
                              <FaCheck />
                            </div>
                          )}
                          <FaTicketAlt className={`addon-icon ${addOnData.addOnType === "variants" ? "active" : ""}`} />
                          <h6 className={`addon-title ${addOnData.addOnType === "variants" ? "active" : ""}`}>
                            With Variants
                          </h6>
                          <p className={`addon-desc ${addOnData.addOnType === "variants" ? "active" : ""}`}>
                            Multiple options
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>

                  {/* Image Upload */}
                  <div style={{ marginBottom: "32px" }}>
                    <h5 className="addon_subheading">
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          fontSize: "16px",
                        }}
                      >
                        <FaImage />
                      </div>
                      Add-on Image
                    </h5>
                    <input
                      type="file"
                      ref={fileInputRef}
                      accept="image/jpeg,image/png,image/jpg"
                      style={{ display: "none" }}
                      onChange={handleImageUpload}
                    />
                    {!uploadedLogo ? (
                      <div
                        onClick={() => fileInputRef.current.click()}
                        style={{
                          border: "2px dashed #cbd5e1",
                          borderRadius: "12px",
                          padding: "20px",
                          textAlign: "center",
                          cursor: "pointer",
                          background: "linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = "#184778"
                          e.currentTarget.style.background = "linear-gradient(to bottom, #e8f2f9 0%, #f8fafc 100%)"
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "#cbd5e1"
                          e.currentTarget.style.background = "linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)"
                        }}
                      >
                        <div
                          style={{
                            width: "56px",
                            height: "56px",
                            background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 16px",
                            color: "#ffffff",
                            fontSize: "24px",
                          }}
                        >
                          <FaImage />
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "600", color: "#184778", marginBottom: "8px" }}>
                          Upload Image
                        </div>
                        <div style={{ fontSize: "13px", color: "#6b7280" }}>
                          JPG, PNG • 150×100 recommended • Max 5MB
                        </div>
                      </div>
                    ) : (
                      <div style={{ position: "relative", display: "inline-block" }}>
                        <img
                          src={uploadedLogo || "/placeholder.svg"}
                          alt="Add-on preview"
                          style={{
                            width: "160px",
                            height: "106px",
                            borderRadius: "12px",
                            objectFit: "cover",
                            border: "2px solid #e5e7eb",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                          }}
                        />
                        <button
                          onClick={handleRemoveImage}
                          className="btn"
                          style={{
                            position: "absolute",
                            top: "-10px",
                            right: "-10px",
                            background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
                            border: "2px solid #ffffff",
                            borderRadius: "50%",
                            width: "32px",
                            height: "32px",
                            color: "#ffffff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            fontSize: "14px",
                            boxShadow: "0 4px 12px rgba(220, 38, 38, 0.4)",
                            transition: "all 0.2s ease",
                            padding: 0,
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "rotate(90deg) scale(1.1)"
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "rotate(0deg) scale(1)"
                          }}
                        >
                          <FaTimes />
                        </button>
                      </div>
                    )}
                    {imageError && (
                      <div style={{ fontSize: "13px", color: "#dc2626", marginTop: "10px", fontWeight: "500" }}>
                        {imageError}
                      </div>
                    )}
                  </div>

                  {/* Basic Information */}
                  <div style={{ marginBottom: "32px" }}>
                    <h5 className="addon_subheading">
                      Basic Information
                    </h5>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label
                          className="form-label"
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#374151",
                            marginBottom: "8px",
                            display: "block",
                          }}
                        >
                          Add-on Name <span style={{ color: "#dc2626" }}>*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter add-on name"
                          className="form-control"
                          style={{
                            padding: "12px 16px",
                            border: "2px solid #e5e7eb",
                            borderRadius: "10px",
                            fontSize: "14px",
                            transition: "all 0.2s ease",
                          }}
                          name="name"
                          value={addOnData.name}
                          onChange={handleInputChange}
                          required
                          onFocus={(e) => {
                            e.target.style.borderColor = "#184778"
                            e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#e5e7eb"
                            e.target.style.boxShadow = "none"
                          }}
                        />
                      </div>
                      {addOnData.addOnType !== "variants" &&
                        <div className="col-md-6">
                          <label
                            className="form-label"
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Quantity Available
                          </label>
                          <input
                            type="number"
                            placeholder="Leave blank for unlimited"
                            className="form-control"
                            style={{
                              padding: "12px 16px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "10px",
                              fontSize: "14px",
                              transition: "all 0.2s ease",
                            }}
                            name="quantity"
                            value={addOnData.quantity}
                            onChange={handleInputChange}
                            onFocus={(e) => {
                              e.target.style.borderColor = "#184778"
                              e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = "#e5e7eb"
                              e.target.style.boxShadow = "none"
                            }}
                          />
                          <small
                            className="form-text"
                            style={{ color: "#6b7280", fontSize: "12px", marginTop: "4px", display: "block" }}
                          >
                            Leave blank for unlimited
                          </small>
                        </div>
                      }

                    </div>
                  </div>

                  {/* Description */}
                  <div style={{ marginBottom: "32px" }}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "14px", fontWeight: "600", color: "#374151", margin: 0 }}
                      >
                        Description
                      </label>
                      <button
                        onClick={
                          showDescription || addOnData.description ? handleRemoveDescription : handleAddDescription
                        }
                        className="btn"
                        style={{
                          background: "transparent",
                          border: "2px solid #184778",
                          borderRadius: "8px",
                          color: "#184778",
                          padding: "8px 16px",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#184778"
                          e.currentTarget.style.color = "#ffffff"
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent"
                          e.currentTarget.style.color = "#184778"
                        }}
                      >
                        {showDescription || addOnData.description ? "Remove" : "Add Description"}
                      </button>
                    </div>
                    {(showDescription || addOnData.description) && (
                      <>
                        <textarea
                          placeholder="Describe your add-on..."
                          className="form-control"
                          rows={4}
                          name="description"
                          value={addOnData.description}
                          onChange={handleInputChange}
                          style={{
                            padding: "12px 16px",
                            border: "2px solid #e5e7eb",
                            borderRadius: "10px",
                            fontSize: "14px",
                            resize: "vertical",
                            transition: "all 0.2s ease",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#184778"
                            e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#e5e7eb"
                            e.target.style.boxShadow = "none"
                          }}
                        />
                        <small
                          className="form-text"
                          style={{ color: "#6b7280", fontSize: "12px", marginTop: "6px", display: "block" }}
                        >
                          This will be shown to customers
                        </small>
                      </>
                    )}
                  </div>

                  {/* Pricing */}
                  <div style={{ marginBottom: "32px" }}>
                    <h5 className="addon_subheading">
                      Pricing
                    </h5>
                    <div className="row g-3 addon_top_tab">
                      {/* Free Pricing Card */}
                      <div className="col-md-6">
                        <div
                          onClick={() => setAddOnData({ ...addOnData, pricing: "free" })}
                          className={`addon-card ${addOnData.pricing === "free" ? "active" : ""}`}
                        >
                          {addOnData.pricing === "free" && (
                            <div className="addon-check">
                              <FaCheck />
                            </div>
                          )}
                          <h6 className={`addon-title ${addOnData.pricing === "free" ? "active" : ""}`}>Free</h6>
                          <p className={`addon-desc ${addOnData.pricing === "free" ? "active" : ""}`}>No cost</p>
                        </div>
                      </div>

                      {/* Paid Pricing Card */}
                      <div className="col-md-6">
                        <div
                          onClick={() => setAddOnData({ ...addOnData, pricing: "paid" })}
                          className={`addon-card ${addOnData.pricing === "paid" ? "active" : ""}`}
                        >
                          {addOnData.pricing === "paid" && (
                            <div className="addon-check">
                              <FaCheck />
                            </div>
                          )}
                          <h6 className={`addon-title ${addOnData.pricing === "paid" ? "active" : ""}`}>Paid</h6>
                          <p className={`addon-desc ${addOnData.pricing === "paid" ? "active" : ""}`}>Set price</p>
                        </div>
                      </div>
                    </div>

                  </div>

                  {/* Paid Pricing Details */}
                  {addOnData.pricing === "paid" && (
                    <>
                      <div className="row g-3 mb-4">
                        <div className="col-md-6">
                          <label
                            className="form-label"
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Currency <span style={{ color: "#dc2626" }}>*</span>
                          </label>
                          <select
                            className="form-select"
                            style={{
                              padding: "12px 16px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "10px",
                              fontSize: "14px",
                              transition: "all 0.2s ease",
                            }}
                            name="currency"
                            value={addOnData.currency}
                            onChange={handleInputChange}
                            onFocus={(e) => {
                              e.target.style.borderColor = "#184778"
                              e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = "#e5e7eb"
                              e.target.style.boxShadow = "none"
                            }}
                          >
                            <option value="">Select Currency</option>
                            <option value="USD">USD - US Dollar</option>
                            <option value="INR">INR - Indian Rupee</option>
                            <option value="EUR">EUR - Euro</option>
                            <option value="GBP">GBP - British Pound</option>
                          </select>
                        </div>
                        {addOnData.addOnType !== "variants" &&
                          <div className="col-md-6">
                            <label
                              className="form-label"
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#374151",
                                marginBottom: "8px",
                                display: "block",
                              }}
                            >
                              Price <span style={{ color: "#dc2626" }}>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="0.00"
                              className="form-control"
                              style={{
                                padding: "12px 16px",
                                border: "2px solid #e5e7eb",
                                borderRadius: "10px",
                                fontSize: "14px",
                                transition: "all 0.2s ease",
                              }}
                              name="price"
                              value={addOnData.price}
                              onChange={handleInputChange}
                              onFocus={(e) => {
                                e.target.style.borderColor = "#184778"
                                e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                              }}
                              onBlur={(e) => {
                                e.target.style.borderColor = "#e5e7eb"
                                e.target.style.boxShadow = "none"
                              }}
                            />
                          </div>}
                      </div>

                      {/* Tax Settings */}
                      <div
                        className="card"
                        style={{
                          background: "linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)",
                          border: "2px solid #e5e7eb",
                          borderRadius: "12px",
                          padding: "24px",
                          marginBottom: "32px",
                        }}
                      >
                        <div className="d-flex align-items-center mb-3">
                          <input
                            type="checkbox"
                            id="tax-switch"
                            className="form-check-input"
                            checked={addOnData.taxEnabled}
                            onChange={handleTaxToggle}
                            style={{
                              width: "20px",
                              height: "20px",
                              marginRight: "12px",
                              cursor: "pointer",
                              accentColor: "#184778",
                            }}
                          />
                          <label
                            htmlFor="tax-switch"
                            className="form-check-label"
                            style={{ fontSize: "16px", fontWeight: "600", cursor: "pointer", color: "#1f2937" }}
                          >
                            Enable Tax
                          </label>
                        </div>
                        <p style={{ color: "#6b7280", fontSize: "13px", marginBottom: "16px" }}>
                          Apply taxes to this add-on
                        </p>
                        <Alert
                      variant="info"
                      style={{
                        background: "#e3f2fd",
                        border: "1px solid #bbdefb",
                        borderRadius: "8px",
                        padding: "12px 15px",
                        marginBottom: "20px",
                        fontSize: "14px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <FaInfoCircle />
                        <span>
                        If the Event state and the Organization state are the same, SGST + CGST will be calculated; otherwise, if the states differ, IGST will be applied.                        </span>
                      </div>
                    </Alert>
                        {addOnData.taxEnabled && (
                          <div
                            className="card"
                            style={{
                              background: "#ffffff",
                              border: "2px solid #e5e7eb",
                              borderRadius: "10px",
                              padding: "20px",
                            }}
                          >
                            <div
                              style={{ fontSize: "15px", fontWeight: "600", marginBottom: "12px", color: "#1f2937" }}
                            >
                              Applied Taxes
                            </div>
                            {addOnData.taxes.length > 0 ? (
                              addOnData.taxes.map((tax, index) => (
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "12px 0",
                                    borderBottom: index < addOnData.taxes.length - 1 ? "1px solid #f3f4f6" : "none",
                                  }}
                                >
                                  <div>
                                    <strong style={{ color: "#1f2937" }}>{tax.name}</strong> - {tax.percentage}%
                                  </div>
                                  <div style={{ fontSize: "12px", color: "#6b7280" }}>
                                    Reg: {tax.registrationNumber}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div style={{ color: "#6b7280", fontStyle: "italic", fontSize: "13px" }}>
                                No taxes configured
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {/* Variants Section */}
                  {addOnData.addOnType === "variants" && (
                    <div
                      className="card"
                      style={{
                        background: "linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)",
                        border: "2px solid #e5e7eb",
                        borderRadius: "12px",
                        padding: "24px",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="addon_subheading">
                          Variants <span style={{ color: "#dc2626" }}>*</span>
                        </h5>
                        {addOnData.variants.length > 0 && (
                          <button
                            onClick={() => setAddOnData({ ...addOnData, variants: [] })}
                            className="btn"
                            style={{
                              background: "transparent",
                              border: "2px solid #dc2626",
                              borderRadius: "8px",
                              color: "#dc2626",
                              padding: "8px 16px",
                              fontSize: "13px",
                              fontWeight: "600",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#dc2626"
                              e.currentTarget.style.color = "#ffffff"
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "transparent"
                              e.currentTarget.style.color = "#dc2626"
                            }}
                          >
                            Clear All
                          </button>
                        )}
                      </div>
                      <p style={{ color: "#6b7280", fontSize: "13px", marginBottom: "16px" }}>
                        Add different options for your add-on
                      </p>

                      {/* <div style={{ marginBottom: "16px" }}>
                        <label
                          className="form-label"
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#374151",
                            marginBottom: "8px",
                            display: "block",
                          }}
                        >
                          Variant Type
                        </label>
                        <input
                          type="text"
                          placeholder="e.g., Size, Color, Type"
                          className="form-control"
                          style={{
                            padding: "12px 16px",
                            border: "2px solid #e5e7eb",
                            borderRadius: "10px",
                            fontSize: "14px",
                            transition: "all 0.2s ease",
                          }}
                          name="variantType"
                          value={addOnData.variantType}
                          onChange={handleInputChange}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#184778"
                            e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#e5e7eb"
                            e.target.style.boxShadow = "none"
                          }}
                        />
                      </div> */}

                      {/* Replaced "Added Variants" section start */}
                      {addOnData.variants.length > 0 ? (
                        <div
                          style={{
                            marginBottom: "16px",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "15px",
                              fontWeight: "600",
                              marginBottom: "16px",
                              color: "#1f2937",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <div
                              style={{
                                width: "28px",
                                height: "28px",
                                background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                                borderRadius: "6px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#ffffff",
                                fontSize: "12px",
                                fontWeight: "700",
                              }}
                            >
                              {addOnData.variants.length}
                            </div>
                            Added Variants
                          </div>
                          <div style={{ display: "grid", gap: "12px" }}>
                            {addOnData.variants.map((variant, index) => (
                              <div
                                key={index}
                                style={{
                                  background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                                  border: "2px solid #e5e7eb",
                                  borderRadius: "12px",
                                  padding: "16px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  transition: "all 0.3s ease",
                                  position: "relative",
                                  overflow: "hidden",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.borderColor = "#184778"
                                  e.currentTarget.style.transform = "translateY(-2px)"
                                  e.currentTarget.style.boxShadow = "0 8px 24px rgba(24, 71, 120, 0.15)"
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.borderColor = "#e5e7eb"
                                  e.currentTarget.style.transform = "translateY(0)"
                                  e.currentTarget.style.boxShadow = "none"
                                }}
                              >
                                {/* Decorative accent */}
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "4px",
                                    height: "100%",
                                    background: "linear-gradient(180deg, #184778 0%, #2563a8 100%)",
                                    borderRadius: "12px 0 0 12px",
                                  }}
                                />

                                <div style={{ flex: 1, paddingLeft: "12px" }}>
                                  <div
                                    style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}
                                  >
                                    <div
                                      style={{
                                        background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                                        color: "#ffffff",
                                        fontSize: "11px",
                                        fontWeight: "700",
                                        padding: "4px 10px",
                                        borderRadius: "6px",
                                        letterSpacing: "0.5px",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      Variant {index + 1}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color: "#1f2937",
                                        letterSpacing: "-0.2px",
                                      }}
                                    >
                                      {variant.name}
                                    </div>
                                  </div>

                                  <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
                                    {variant.quantity && (
                                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <div
                                          style={{
                                            width: "28px",
                                            height: "28px",
                                            background: "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "12px",
                                            color: "#374151",
                                          }}
                                        >
                                          📦
                                        </div>
                                        <div>
                                          <div style={{ fontSize: "11px", color: "#6b7280", fontWeight: "500" }}>
                                            Quantity
                                          </div>
                                          <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                                            {variant.quantity}
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                      <div
                                        style={{
                                          width: "28px",
                                          height: "28px",
                                          background: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
                                          borderRadius: "6px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          fontSize: "12px",
                                          color: "#166534",
                                        }}
                                      >
                                        💰
                                      </div>
                                      <div>
                                        <div style={{ fontSize: "11px", color: "#6b7280", fontWeight: "500" }}>
                                          Price
                                        </div>
                                        <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                                          {addOnData.currency || "USD"} {variant.price}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <button
                                  onClick={() => handleRemoveVariant(index)}
                                  className="btn"
                                  style={{
                                    background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
                                    border: "2px solid #fca5a5",
                                    borderRadius: "10px",
                                    color: "#dc2626",
                                    width: "40px",
                                    height: "40px",
                                    minWidth: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                    transition: "all 0.2s ease",
                                    padding: 0,
                                    flexShrink: 0,
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)"
                                    e.currentTarget.style.borderColor = "#dc2626"
                                    e.currentTarget.style.color = "#ffffff"
                                    e.currentTarget.style.transform = "scale(1.05) rotate(-5deg)"
                                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(220, 38, 38, 0.4)"
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)"
                                    e.currentTarget.style.borderColor = "#fca5a5"
                                    e.currentTarget.style.color = "#dc2626"
                                    e.currentTarget.style.transform = "scale(1) rotate(0deg)"
                                    e.currentTarget.style.boxShadow = "none"
                                  }}
                                >
                                  <FaTimes />
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            color: "#6b7280",
                            textAlign: "center",
                            padding: "40px 32px",
                            background: "linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)",
                            borderRadius: "12px",
                            border: "2px dashed #cbd5e1",
                            marginBottom: "16px",
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "-20px",
                              right: "-20px",
                              width: "100px",
                              height: "100px",
                              background:
                                "linear-gradient(135deg, rgba(24, 71, 120, 0.05) 0%, rgba(37, 99, 168, 0.05) 100%)",
                              borderRadius: "50%",
                              filter: "blur(20px)",
                            }}
                          />
                          <div
                            style={{
                              width: "56px",
                              height: "56px",
                              background: "linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%)",
                              borderRadius: "12px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "0 auto 16px",
                              fontSize: "24px",
                            }}
                          >
                            📋
                          </div>
                          <div style={{ fontSize: "15px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>
                            No variants added yet
                          </div>
                          <div style={{ fontSize: "13px", color: "#6b7280" }}>
                            Click "Add Variant" below to create your first variant option
                          </div>
                        </div>
                      )}
                      {/* Replaced "Added Variants" section end */}

                      <button
                        onClick={() => setShowVariantModal(true)}
                        className="btn"
                        style={{
                          background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                          border: "none",
                          borderRadius: "10px",
                          color: "#ffffff",
                          padding: "12px 20px",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                          boxShadow: "0 4px 12px rgba(24, 71, 120, 0.3)",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)"
                          e.currentTarget.style.boxShadow = "0 6px 20px rgba(24, 71, 120, 0.4)"
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)"
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 71, 120, 0.3)"
                        }}
                      >
                        <FaPlus />
                        Add Variant
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {isLoadingTickets && (
                    <div style={{ textAlign: "center", padding: "60px", color: "#6b7280" }}>
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          border: "4px solid #e5e7eb",
                          borderTop: "4px solid #184778",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                          margin: "0 auto 16px",
                        }}
                      />
                      Loading tickets...
                    </div>
                  )}
                  {ticketError && (
                    <div
                      className="alert alert-danger"
                      style={{
                        color: "#dc2626",
                        padding: "24px",
                        textAlign: "center",
                        background: "#fef2f2",
                        borderRadius: "10px",
                        border: "2px solid #fecaca",
                      }}
                    >
                      {ticketError}
                    </div>
                  )}
                  {!isLoadingTickets && !ticketError && ticketList.length === 0 && (
                    <div
                      style={{
                        color: "#6b7280",
                        padding: "24px",
                        textAlign: "center",
                        background: "#f9fafb",
                        borderRadius: "10px",
                        border: "2px dashed #d1d5db",
                      }}
                    >
                      No tickets available for this event.
                    </div>
                  )}
                  {!isLoadingTickets && !ticketError && ticketList.length > 0 && renderLinkedToTab()}
                </div>
              )}
            </div>

            {/* Footer */}
            <div
              style={{
                background: "linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)",
                padding: "20px 32px",
                borderTop: "2px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div></div>
              <div style={{ display: "flex", gap: "12px" }}>
                {activeTab === "basic" ? (
                  <button
                    onClick={goToLinkedTab}
                    disabled={!addOnData.name}
                    className="btn"
                    style={{
                      background: !addOnData.name ? "#9ca3af" : "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                      border: "none",
                      borderRadius: "10px",
                      color: "#ffffff",
                      padding: "12px 24px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: !addOnData.name ? "not-allowed" : "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.2s ease",
                      boxShadow: !addOnData.name ? "none" : "0 4px 12px rgba(24, 71, 120, 0.3)",
                      opacity: !addOnData.name ? 0.6 : 1,
                    }}
                    onMouseEnter={(e) => {
                      if (addOnData.name) {
                        e.currentTarget.style.transform = "translateY(-2px)"
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(24, 71, 120, 0.4)"
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (addOnData.name) {
                        e.currentTarget.style.transform = "translateY(0)"
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 71, 120, 0.3)"
                      }
                    }}
                  >
                    Continue
                    <FaArrowRight />
                  </button>
                ) : (
                  <>
                    <button
                      onClick={goToBasicTab}
                      className="btn"
                      style={{
                        background: "transparent",
                        border: "2px solid #6b7280",
                        borderRadius: "10px",
                        color: "#6b7280",
                        padding: "12px 24px",
                        fontSize: "14px",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#6b7280"
                        e.currentTarget.style.color = "#ffffff"
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent"
                        e.currentTarget.style.color = "#6b7280"
                      }}
                    >
                      Back
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="btn"
                      style={{
                        background: "linear-gradient(135deg, rgb(24, 71, 120) 0%, rgb(37, 99, 168) 100%)",
                        border: "none",
                        borderRadius: "10px",
                        color: "#ffffff",
                        padding: "12px 24px",
                        fontSize: "14px",
                        fontWeight: "600",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        transition: "all 0.2s ease",
                        boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)"
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.4)"
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)"
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.3)"
                      }}
                    >
                      <FaCheck />
                      {addOnData.id ? "Update Add-on" : "Create Add-on"}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Variant Modal */}
      <Modal show={showVariantModal} onHide={() => setShowVariantModal(false)} centered>
        <div style={{ borderRadius: "12px", overflow: "hidden" }}>
          <Modal.Header
            style={{
              background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
              color: "#ffffff",
              border: "none",
              padding: "24px",
              position: "relative",
            }}
          >
            <Modal.Title style={{ fontSize: "18px", fontWeight: "700" }}>Add New Variant</Modal.Title>
            <button
              onClick={() => setShowVariantModal(false)}
              className="btn-close"
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                background: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                border: "none",
                borderRadius: "8px",
                color: "#ffffff",
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                fontSize: "16px",
                transition: "all 0.2s ease",
                opacity: 1,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.3)"
                e.currentTarget.style.transform = "rotate(90deg)"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)"
                e.currentTarget.style.transform = "rotate(0deg)"
              }}
            >
              <FaTimes />
            </button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <div className="mb-3" style={{ marginBottom: "20px" }}>
              <label
                className="form-label"
                style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}
              >
                Variant Name <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="e.g., Large, Medium, Small"
                className="form-control"
                style={{
                  padding: "12px 16px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "10px",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                }}
                name="name"
                value={currentVariant.name}
                onChange={handleVariantInputChange}
                required
                onFocus={(e) => {
                  e.target.style.borderColor = "#184778"
                  e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e5e7eb"
                  e.target.style.boxShadow = "none"
                }}
              />
            </div>

            <div className="mb-3" style={{ marginBottom: "20px" }}>
              <label
                className="form-label"
                style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}
              >
                Quantity Available
              </label>
              <input
                type="number"
                placeholder="Leave blank for unlimited"
                className="form-control"
                style={{
                  padding: "12px 16px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "10px",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                }}
                name="quantity"
                value={currentVariant.quantity}
                onChange={handleVariantInputChange}
                onFocus={(e) => {
                  e.target.style.borderColor = "#184778"
                  e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e5e7eb"
                  e.target.style.boxShadow = "none"
                }}
              />
              <small
                className="form-text"
                style={{ color: "#6b7280", fontSize: "12px", marginTop: "4px", display: "block" }}
              >
                Leave blank for unlimited
              </small>
            </div>

            <div className="mb-3" style={{ marginBottom: "20px" }}>
              <label
                className="form-label"
                style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}
              >
                Variant Price <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <input
                type="number"
                placeholder="0.00"
                className="form-control"
                style={{
                  padding: "12px 16px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "10px",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                }}
                name="price"
                value={currentVariant.price}
                onChange={handleVariantInputChange}
                required
                onFocus={(e) => {
                  e.target.style.borderColor = "#184778"
                  e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e5e7eb"
                  e.target.style.boxShadow = "none"
                }}
              />
              <small
                className="form-text"
                style={{ color: "#6b7280", fontSize: "12px", marginTop: "4px", display: "block" }}
              >
                Enter the price for this variant
              </small>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{
              background: "linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)",
              borderTop: "2px solid #e5e7eb",
              padding: "20px 24px",
            }}
          >
            <button
              onClick={() => {
                setShowVariantModal(false)
                setActiveTab("basic")
              }}
              className="btn"
              style={{
                background: "transparent",
                border: "2px solid #6b7280",
                borderRadius: "8px",
                color: "#6b7280",
                padding: "10px 20px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#6b7280"
                e.currentTarget.style.color = "#ffffff"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent"
                e.currentTarget.style.color = "#6b7280"
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleAddVariant}
              disabled={!currentVariant.name || !currentVariant.price}
              className="btn"
              style={{
                background:
                  !currentVariant.name || !currentVariant.price
                    ? "#9ca3af"
                    : "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                border: "none",
                borderRadius: "8px",
                color: "#ffffff",
                padding: "10px 20px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: !currentVariant.name || !currentVariant.price ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.2s ease",
                opacity: !currentVariant.name || !currentVariant.price ? 0.6 : 1,
                boxShadow: !currentVariant.name || !currentVariant.price ? "none" : "0 4px 12px rgba(24, 71, 120, 0.3)",
              }}
              onMouseEnter={(e) => {
                if (currentVariant.name && currentVariant.price) {
                  e.currentTarget.style.transform = "translateY(-2px)"
                  e.currentTarget.style.boxShadow = "0 6px 20px rgba(24, 71, 120, 0.4)"
                }
              }}
              onMouseLeave={(e) => {
                if (currentVariant.name && currentVariant.price) {
                  e.currentTarget.style.transform = "translateY(0)"
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 71, 120, 0.3)"
                }
              }}
            >
              <FaPlus />
              Add Variant
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  )
}

export default CreateAddOns
